export default __webpack_public_path__ + "static/Ambit-Regular-b585b3393d001ae813b5a30cab573093.woff2";